/**
 * BoardDashboardPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, ExpandableContainer } from 'components';
import { Divider, Button, Table, Radio, Spin, Statistic } from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
} from '@ant-design/icons';
import {
  CartesianGrid,
  Tooltip,
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Bar,
  Rectangle,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const BoardDashboardPresenter = ({
  loading,
  chartData,
  statisticsType,
  setStatisticsType,
  handleGetCartList,
  inquiryList,
  reviewList,
}) => {
  // console.log('inquiryList: ', inquiryList);
  // console.log('reviewList: ', reviewList);

  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  const formItem = [
    {
      label: '기간설정',
      form: [
        {
          input: (
            <>
              <Radio.Group
                size="large"
                defaultValue="month"
                buttonStyle="solid"
                value={statisticsType}
                onChange={(e) => setStatisticsType(e.target.value)}
                style={{ marginRight: 12 }}
              >
                <Radio.Button value="today">오늘</Radio.Button>
                <Radio.Button value="week">1주일(7일)</Radio.Button>
                <Radio.Button value="month">1개월(30일)</Radio.Button>
                <Radio.Button value="3month">3개월(90일)</Radio.Button>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */

  /*  */
  /* 상품별 데이터 */
  const productChart = chartData?.product
    ? Object.keys(chartData.product).map((item) => ({
        name: chartData.product[item].label,
        value: chartData.product[item].data.length,
        ...chartData.product[item],
      }))
    : [];

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={3} style={{ marginBottom: 12 }}>
              게시판 대시보드
            </Title>

            {/* 검색필터 */}
            {/* <Content
              maxWidth={'100%'}
              padding={0}
              // backgroundColor={'none'}
              style={{ marginBottom: 5 }}
            >
              <Row>
                <Col x={19}>
                  <ExpandableContainer borderRadius={4} padding={20}>
                    {formItem.map((_item, _index) => (
                      <div
                        key={`form_${_index}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 0px',
                        }}
                      >
                        <div
                          style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                        >
                          <label>{_item.label}</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {_item.form.map((_subitem, _subkey) => (
                            <React.Fragment key={`input_${_subkey}`}>
                              {_subitem.input}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    ))}
                  </ExpandableContainer>
                </Col>
                <Col
                  x={5}
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => handleGetCartList()}
                  >
                    <SearchOutlined /> 검색
                  </Button>
                  &nbsp;
                  <Button
                    size="large"
                    // onClick={handleResetFilter}
                  >
                    <ReloadOutlined /> 초기화
                  </Button>
                </Col>
              </Row>
            </Content> */}
            {/* 검색필터 끝 */}

            {/* === 현황 요약: start === */}
            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '상품문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) =>
                        item.inquiry_sub_type === 'BULK' ||
                        item.inquiry_sub_type === 'DETAIL' ||
                        item.inquiry_sub_type === 'RESTOCK' ||
                        item.inquiry_sub_type === 'ORDER'
                    ).length
                  ),
                  suffix: '건',
                  link: '/inquiry/list?inquiry_sub_type=ORDER',
                },
                {
                  title: '서비스문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) => item.inquiry_sub_type === 'SERVICE'
                    ).length
                  ),
                  suffix: '개',
                  link: '/inquiry/list?inquiry_sub_type=SERVICE',
                },
                {
                  title: '회원문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) => item.inquiry_sub_type === 'USER'
                    ).length
                  ),
                  suffix: '개',
                  link: '/inquiry/list?inquiry_sub_type=USER',
                },
                {
                  title: '승인대기 리뷰',
                  value: stringToMoneyFormat(reviewList.length),
                  suffix: '개',
                  link: '/review/list?answer=wait',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: '24px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}
                    valueStyle={{
                      color: '#1677ff',
                      textDecoration: 'underline !important',
                    }}
                  />
                  <div>
                    <Button
                      shape="circle"
                      onClick={() => window.open(_item.link, '_blank')}
                    >
                      <ExportOutlined />
                    </Button>
                  </div>
                </div>
              ))}
            </Content>
            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '배송문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) => item.inquiry_sub_type === 'DELIVERY'
                    ).length
                  ),
                  suffix: '건',
                  link: '/inquiry/list?inquiry_sub_type=DELIVERY',
                },
                {
                  title: '매장문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) => item.inquiry_sub_type === 'STORE'
                    ).length
                  ),
                  suffix: '개',
                  link: '/inquiry/list?inquiry_sub_type=STORE',
                },
                {
                  title: '제이엠페이문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) =>
                        item.inquiry_sub_type === 'JM_PAY' ||
                        item.inquiry_sub_type === 'JM_PAY_REFUND'
                    ).length
                  ),
                  suffix: '개',
                  link: '/inquiry/list?inquiry_sub_type=JM_PAY',
                },
                {
                  title: '기타문의',
                  value: stringToMoneyFormat(
                    inquiryList.filter(
                      (item) => item.inquiry_sub_type === 'ETC'
                    ).length
                  ),
                  suffix: '개',
                  link: '/inquiry/list?inquiry_sub_type=ETC',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: '24px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}
                    valueStyle={{
                      color: '#1677ff',
                      textDecoration: 'underline !important',
                    }}
                  />
                  <div>
                    <Button
                      shape="circle"
                      onClick={() => window.open(_item.link, '_blank')}
                    >
                      <ExportOutlined />
                    </Button>
                  </div>
                </div>
              ))}
            </Content>
            {/* === 현황 요약: end === */}

            {/* ===== 차트: start ===== */}

            {/* ===== 차트: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default BoardDashboardPresenter;
